<template>
    <div class="main-top form-top-section relative pb-24 z-40">
        <div class="section-bg bg-primary-gradient -bottom-half z-10 relative"></div>
        <div class="form-top-section-content container text-center z-10 relative">
            <div class="mx-auto pt-2 w-full md:w-1/2 px-2">
                <h1 class="text-green font-bold text-2xl md:text-3.5xl">Your Little Loans Quote</h1>
                <p
                    class="mt-4 md:mt-5 md:mb-0 text-lg md:text-1.5xl"
                >Get a no-obligation, instant quotation.</p>
            </div>
            <div class="w-full">
                <p class="rep-text text-lg md:text-xl font-normal">Representative {{ rep_apr_ll }}% APR</p>
            </div>
        </div>
    </div>
</template>

<script>
export default { 
    data() {
        return {
            rep_apr_ll: null,
        }
    },
    created() {
        this.rep_apr_ll = window.config.rep_apr_ll;
    }
}
</script>

<style lang="scss">
</style>